import { styled } from '@mui/material/styles';
import React, { ButtonHTMLAttributes } from 'react';

/** The LinkButton is used when UX wants an element that looks like a link (underlined hover),
        but behaves like a button with only a click handler */
export const StyledButton = styled('button')<LinkButtonProps>`
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: none;
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  font: inherit;
  max-width: 100%;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
  &:disabled {
    opacity: ${(props) => props.theme.palette.action.disabledOpacity};
    text-decoration: none;
  }

  &:focus {
    outline: none;
  }
`;

export function LinkButton(props: LinkButtonProps) {
  return <StyledButton {...props} type="button" />;
}

export type LinkButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;
